import { render, staticRenderFns } from "./AutomationLandingCard.vue?vue&type=template&id=30dedf90&scoped=true&"
import script from "./AutomationLandingCard.vue?vue&type=script&lang=js&"
export * from "./AutomationLandingCard.vue?vue&type=script&lang=js&"
import style0 from "./AutomationLandingCard.vue?vue&type=style&index=0&id=30dedf90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dedf90",
  null
  
)

export default component.exports